import SV from 'server-vars';
import { Locale, LOCALE_US } from './constants';
import { isLocale } from './utils';

/**
 * This can run both on the server and the client.
 */
export function getSupportedLocales(logger = console): Locale[] {
    let nodeSupportedLocalesList: string[] = [];
    if (typeof window !== 'undefined') {
        nodeSupportedLocalesList = SV.get('supportedLocales');

        if (!nodeSupportedLocalesList) {
            logger.error('supportedLocales server var not set');
            return [LOCALE_US];
        }
    } else {
        const nodeSupportedLocales = process.env.NODE_SUPPORTED_LOCALES;

        if (!nodeSupportedLocales) {
            logger.error('NODE_SUPPORTED_LOCALES environment variable not set');
            return [LOCALE_US];
        }

        nodeSupportedLocalesList = nodeSupportedLocales.split(',');
    }

    /**
     * Just a sanity check, US locale should always be included.
     */
    if (!nodeSupportedLocalesList.includes(LOCALE_US)) {
        nodeSupportedLocalesList.push(LOCALE_US);
    }

    return nodeSupportedLocalesList.filter(isLocale);
}
